import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWestfieldAppinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeLinecap: "square",
				strokeWidth: 2,
				d: "M31 7L33 7M22 10L44 10"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M15,55 L17,50 L15.298605,44.895815 C15.1022338,44.3067013 15.0457203,43.6799577 15.1335402,43.0652185 L15.8891895,37.7756738 C15.9623678,37.2634257 15.9354612,36.741845 15.8099615,36.2398459 L14.3834825,30.53393 C14.1670929,29.6683715 14.6535874,28.7821375 15.5,28.5 L15.7369879,28.421004 C16.5568856,28.1477048 17.4432473,28.1473055 18.2633909,28.4198661 L20.0090332,29"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeLinecap: "square",
				strokeWidth: 2,
				d: "M38,48 L38,48.5968758 C38,49.5051617 37.690877,50.3864038 37.1234752,51.095656 L35.0976484,53.6279395 C34.3745013,54.5318734 33.4637957,55.2681021 32.4284067,55.7857967 L30.0019569,56.9990215 C28.7022489,57.6488756 27.647506,58.7015624 26.9951172,60"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M37,38 L29.8315594,22.7670637 C29.3691344,21.7844105 29.7754019,20.6122991 30.7467696,20.1266152 L31.2111456,19.8944272 C32.1991026,19.4004487 33.4004487,19.8008974 33.8944272,20.7888544 L40,33"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M44,32 L40.8944272,25.7888544 C40.4004487,24.8008974 39.1991026,24.4004487 38.2111456,24.8944272 L36,26"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M49,33 L45.8944272,26.7888544 C45.4004487,25.8008974 44.1991026,25.4004487 43.2111456,25.8944272 L41,27"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M59 49L57.6717988 47.0076982C57.2337521 46.3506282 57 45.5785974 57 44.7888974L57 40.9442719C57 40.3232915 56.8554196 39.7108393 56.5777088 39.1554175L54 34 50.8944272 27.7888544C50.4004487 26.8008974 49.1991026 26.4004487 48.2111456 26.8944272L46 28M47 55L45.1258306 51.2516612C45.0435412 51.0870823 44.9174381 50.9483988 44.7614023 50.8508765L38.7506698 47.0941686C37.6023662 46.3764789 36.6550289 45.3790521 35.9974031 44.1953257L32.7326423 38.3187561C32.2989822 37.538168 32.4353247 36.5646753 33.0667433 35.9332567L35 34"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeLinecap: "square",
				strokeWidth: 2,
				d: "M37.0769231,46 L21.8461538,46 C20.8265512,46 20,45.1452709 20,44.0909091 L20,5.90909091 C20,4.85472911 20.8265512,4 21.8461538,4 L42.1538462,4 C43.1734488,4 44,4.85472911 44,5.90909091 L44,24.0042059"
			})
		]
	})
});
export default SvgWestfieldAppinline;
